import { createContext, useContext } from 'react';

/**
 * Master prompt §2.5 — атмосферный слой никогда не сбрасывается между секциями.
 * В seamless-flow `<Showcase>` монтирует один глобальный AtmosphericLayer
 * на root-уровне, а per-module экземпляры подавляются через этот контекст.
 *
 * В `/preview/:moduleId` контекст остаётся false → модуль рендерит свою
 * атмосферу как раньше (изолированная iPhone-frame preview).
 */
export const SeamlessFlowContext = createContext<boolean>(false);

export const useSeamlessFlow = (): boolean => useContext(SeamlessFlowContext);
